var _rect, _rect2, _path, _path2, _mask, _path3, _mask2, _path4, _rect3, _rect4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#3892F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(14 14)",
    fill: "#3892F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22H32V29C32 29.5523 31.5523 30 31 30H17C16.4477 30 16 29.5523 16 29V22Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7808 16L29.2192 16L30.7192 22H17.2808L18.7808 16Z",
    stroke: "white",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_1189_3624",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 29H17V33H15V29Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29V27H13V29H15ZM17 29H19V27H17V29ZM17 33V35H19V33H17ZM15 33H13V35H15V33ZM15 31H17V27H15V31ZM15 29V33H19V29H15ZM17 31H15V35H17V31ZM17 33V29H13V33H17Z",
    fill: "white",
    mask: "url(#path-4-inside-1_1189_3624)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_1189_3624",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 29H33V33H31V29Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29V27H29V29H31ZM33 29H35V27H33V29ZM33 33V35H35V33H33ZM31 33H29V35H31V33ZM31 31H33V27H31V31ZM31 29V33H35V29H31ZM33 31H31V35H33V31ZM33 33V29H29V33H33Z",
    fill: "white",
    mask: "url(#path-6-inside-2_1189_3624)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 1,
    height: 1,
    transform: "matrix(-1 0 0 1 20 25)",
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 1,
    height: 1,
    transform: "matrix(-1 0 0 1 28 25)",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22L33 22",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportation);
export default __webpack_public_path__ + "static/media/Transportation.eb04203d4085a5af8b3c463d4e750ef1.svg";
export { ForwardRef as ReactComponent };